export const replaceSpecialCharacters = (value: string) => value && value.replace(/["\n\r]/g, '');
